const mediaTextMapping = (data) => {
  const mappedData = {};
  mappedData.description = data.field_component_body[0]?.value || '';
  mappedData.alignImage = data.field_img_alignment[0]?.value || '';
  mappedData.desktopImage = {
    url: data.field_desktop_img[0]?.url || '',
    alt: data.field_desktop_img[0]?.alt || ''
  };
  mappedData.mobileImage = {
    url: data.field_mobile_img[0]?.url || '',
    alt: data.field_mobile_img[0]?.alt || ''
  };
  mappedData.caption = data.field_img_caption[0]?.value || '';
  return mappedData;
}

export default mediaTextMapping;
